<template>

  <div v-if="type === 'badge'" style="line-height: 0;">

    <v-chip label :x-small="size==='x-small'" :small="size==='small'" :large="size==='large'" :class="classes" class="order-status-badge">
    {{prefix}}{{displayText}}
      <v-icon right :x-small="size==='x-small'" :small="size==='small'" :large="size==='large'" v-if="icon">mdi-chevron-right</v-icon>

    </v-chip>

  </div>


  <span v-else class="order-status-text" :class="value">
    {{displayText}}
  </span>



</template>


<script>


export default {


    name: 'orderStatusBadge',
    props: {


        value: {required: true},
        size: {required: false, default:'small'},
        text: {required: false, default: null},
        prefix: {required: false, default: ''},
        type: {required: false, default: 'badge'},
        icon: {required: false, default: false, type:Boolean},
        block: {required: false, default: false, type:Boolean},

    },

    data(){


        return {

            status: {

                'pending-import': {label: this.$t('order.status.pending-import')},
                'imported': {label: this.$t('order.status.imported')},
                'cart': {label: this.$t('order.status.cart')},
                'preparing': {label: this.$t('order.status.preparing')},
                'offer-request': {label: this.$t('order.status.offer-request')},
                'proposal': {label: this.$t('order.status.proposal')},
                'pending': {label: this.$t('order.status.pending')},
                'pending-confirmation': {label: this.$t('order.status.pending-confirmation')},
                'confirmed': {label: this.$t('order.status.confirmed')},
                'declined': {label: this.$t('order.status.declined')},
                'on-hold': {label: this.$t('order.status.on-hold')},
                'processing': {label: this.$t('order.status.processing')},
                'preparing-for-pickup': {label: this.$t('order.status.preparing-for-pickup')},
                'ready-for-pickup': {label: this.$t('order.status.ready-for-pickup')},
                'ready-for-shipment': {label: this.$t('order.status.ready-for-shipment')},
                'preparing-for-shipment': {label: this.$t('order.status.preparing-for-shipment')},
                'ready-for-shipping': {label: this.$t('order.status.ready-for-shipping')},
                'partial-shipment': {label: this.$t('order.status.partial-shipment')},
                'order-in-transit': {label: this.$t('order.status.order-in-transit')},
                'picked-up': {label: this.$t('order.status.picked-up')},
                'completed': {label: this.$t('order.status.completed')},
                'debt-collection': {label: this.$t('order.status.debt-collection')},
                'partial-refund': {label: this.$t('order.status.partial-refund')},
                'refunded': {label: this.$t('order.status.refunded')},
                'failed': {label: this.$t('order.status.failed')},
                'cancelled': {label: this.$t('order.status.cancelled')},
                'debt-default': {label: this.$t('order.status.debt-default')},


            }


        }

    },

    computed: {


        classes: function(){


          let classes = [];


          classes.push(this.value);

          if(this.block){
            classes.push('block');
          }

          return classes;

        },

        displayText: function(){

            let self = this;

            if(self.text){
                return self.text;
            }

            if(self.status[self.value]){


                return self.status[self.value].label;

            }


            return self.value;

        }

    }

}

</script>

<style scoped lang="scss">
@import '~@/scss/_order-status-colors.scss';

.order-status-badge {

  &.block {
    width: 100%;
  }

  // Neutral (grau) - Import, Cart
  &.pending-import, &.imported, &.cart {
    background-color: $order-status-neutral-bg;
    color: $order-status-neutral-text;
  }

  // Preparing (hellblau) - In Vorbereitung, Angebotsanfrage
  &.preparing, &.offer-request, &.pending-confirmation, &.confirmed {
    background-color: $order-status-preparing-bg;
    color: $order-status-preparing-text;
  }

  // Proposal (golden) - Angebot verschickt
  &.proposal {
    background-color: $order-status-proposal-bg;
    color: $order-status-proposal-text;
  }

  // Warning (amber) - Zahlung ausstehend, In Wartestellung
  &.pending, &.on-hold {
    background-color: $order-status-warning-bg;
    color: $order-status-warning-text;
  }

  // Success (grün) - In Bearbeitung
  &.processing {
    background-color: $order-status-success-bg;
    color: $order-status-success-text;
  }

  // Shipping (lila) - Versandvorbereitungen
  &.preparing-for-shipment, &.ready-for-shipping, &.partial-shipment {
    background-color: $order-status-shipping-bg;
    color: $order-status-shipping-text;
  }

  // Pickup Prep (hellviolett) - Abholvorbereitungen
  &.preparing-for-pickup {
    background-color: $order-status-pickup-prep-bg;
    color: $order-status-pickup-prep-text;
  }

  // Pickup (türkis) - Bereit zur Abholung
  &.ready-for-pickup {
    background-color: $order-status-pickup-bg;
    color: $order-status-pickup-text;
  }

  // Transit (stahlblau) - Verschickt
  &.order-in-transit {
    background-color: $order-status-transit-bg;
    color: $order-status-transit-text;
  }

  // Completed (blau-grau) - Abgeschlossen
  &.completed, &.picked-up {
    background-color: $order-status-completed-bg;
    color: $order-status-completed-text;
  }

  // Failed (leuchtendes Rot) - Fehlgeschlagen
  &.failed {
    background-color: $order-status-failed-bg;
    color: $order-status-failed-text;
  }

  // Cancelled (dunkel) - Storniert
  &.cancelled, &.declined {
    background-color: $order-status-cancelled-bg;
    color: $order-status-cancelled-text;
  }

  // Partial Refund (mittelgrau) - Teilweise zurückerstattet
  &.partial-refund {
    background-color: $order-status-partial-refund-bg;
    color: $order-status-partial-refund-text;
  }

  // Refunded (dunkelgrau) - Vollständig zurückerstattet
  &.refunded {
    background-color: $order-status-refunded-bg;
    color: $order-status-refunded-text;
  }

  // Debt (dunkelrot) - Mahnverfahren
  &.debt-collection, &.debt-default {
    background-color: $order-status-debt-bg;
    color: $order-status-debt-text;
  }

}

.order-status-text {
  font-weight: bold;

  &.pending-import, &.imported, &.cart { color: $order-status-neutral-text; }
  &.preparing, &.offer-request, &.pending-confirmation, &.confirmed { color: $order-status-preparing-text; }
  &.proposal { color: $order-status-proposal-text; }
  &.pending, &.on-hold { color: $order-status-warning-text; }
  &.processing { color: $order-status-success-text; }
  &.preparing-for-shipment, &.ready-for-shipping, &.partial-shipment { color: $order-status-shipping-text; }
  &.preparing-for-pickup { color: $order-status-pickup-prep-text; }
  &.ready-for-pickup { color: $order-status-pickup-text; }
  &.order-in-transit { color: $order-status-transit-text; }
  &.completed, &.picked-up { color: $order-status-completed-text; }
  &.failed { color: $order-status-failed-text; }
  &.cancelled, &.declined { color: $order-status-cancelled-text; }
  &.partial-refund { color: $order-status-partial-refund-text; }
  &.refunded { color: $order-status-refunded-text; }
  &.debt-collection, &.debt-default { color: $order-status-debt-text; }

}

</style>
